module.exports = __webpack_public_path__ + "img/half-pink.25538494.png";